let EmailBroadcastsIndexTourSteps  = {
  tourSteps: function() {
    return [
      {
        content: 'The eBlasts page lists the eBlasts you have created.',
        target: '.help_icon_smaller',
        placement: 'bottom',
        disableBeacon: true
      },
      {
        content: "This is the date the eBlast was sent.",
        target: '.email_broadcast_date',
        placement: 'top',
        disableBeacon: true
      },
      {
        content: "This is the sending status of the eBlast. Throttled: This eblast is currently being throttled due to too many email bounces. The emails will be sent out slowly. To avoid being throttled, make sure that you are only sending emails to valid email addresses and with content that is not considered spammy. More Info: https://blog.hubspot.com/blog/tabid/6307/bid/30594/a-marketer-s-guide-to-getting-past-email-spam-filters.aspx Sending: This eblast is currently being processed. Sent: This eblast has been processed.",
        target: '.email_broadcast_status',
        placement: 'bottom',
        disableBeacon: true
      },
      {
        content: "This is the name of the eBlast.",
        target: '.email_broadcast_name',
        placement: 'top',
        disableBeacon: true
      },
      {
        content: "This is the subject of the eBlast.",
        target: '.email_broadcast_subject',
        placement: 'top',
        disableBeacon: true
      },
      {
        content: "This is the number of times emails from this eBlast have been queued for delivery.",
        target: '.email_stats_queued',
        placement: 'top',
        disableBeacon: true
      },
      {
        content: "This is the number of times emails from this eBlast have been delivered.",
        target: '.email_stats_delivered',
        placement: 'top',
        disableBeacon: true
      },
      {
        content: "This is the number of times emails from this eBlast have been opened.",
        target: '.email_stats_opened',
        placement: 'top',
        disableBeacon: true
      },
      {
        content: "This is the number of times emails from this eBlast have been clicked.",
        target: '.email_stats_clicked',
        placement: 'top',
        disableBeacon: true
      },
      {
        content: "This is the number of times a customer has unsubscribed using an email from this eBlast.",
        target: '.email_stats_unsubscribed',
        placement: 'top',
        disableBeacon: true
      },
      {
        content: "This is the number of times a customer has submitted a spam report using an email from this eBlast.",
        target: '.email_stats_spam_report',
        placement: 'top',
        disableBeacon: true
      },
      {
        content: "This is the number of times an email from this eBlast has bounced. Common reasons for emails bouncing are incorrect addresses or full mailboxes.",
        target: '.email_stats_bounced',
        placement: 'top',
        disableBeacon: true
      },
      {
        content: "This is the number of times an email from this eBlast has failed to send. Common reasons for email failures are incorrect addresses or full mailboxes.",
        target: '.email_stats_failed',
        placement: 'top',
        disableBeacon: true
      },
      {
        content: "Click here to view emails sent as part of this eBlast.",
        target: '.eblast_emails',
        placement: 'top',
        disableBeacon: true
      }
    ];
  }
};

export default EmailBroadcastsIndexTourSteps;
